import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ClearIcon from '@mui/icons-material/Clear';
import SaveIcon from '@mui/icons-material/Save';
import AutoAwesomeMosaicIcon from '@mui/icons-material/AutoAwesomeMosaic';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CircularProgress from '../CircularProgress';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PrintIcon from '@mui/icons-material/Print';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import SendIcon from '@mui/icons-material/Send';
import CancelScheduleSendIcon from '@mui/icons-material/CancelScheduleSend';
import WorkOffIcon from '@mui/icons-material/WorkOff';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import MuiIconButton, { IconButtonProps } from '@mui/material/IconButton';
import { ReactNode } from 'react';
import { buttonType } from 'src/core/types';
import { isVisible } from 'src/utils/formAuthHelper';
import Tooltip from '../Tooltip';
import RemoveIcon from '@mui/icons-material/Remove';
import { SxProps, Theme } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import PolicyIcon from '@mui/icons-material/Policy';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ModulEnum from "src/enums/ModulEnum";
import VideocamIcon from '@mui/icons-material/Videocam';
import DomainAddIcon from '@mui/icons-material/DomainAdd';
import { BorderColor, DisabledByDefault, Grading, MoveDown, PictureAsPdf, Star, StarBorder, SwapHorizontalCircle, NotificationImportant } from '@mui/icons-material';
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import DownloadIcon from '@mui/icons-material/Download';
import PanoramaIcon from '@mui/icons-material/Panorama';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import UndoIcon from '@mui/icons-material/Undo';
import ScienceIcon from '@mui/icons-material/Science';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import { translate } from 'src/i18n/tHelper';
import { SgkIcon } from '../Icons/SgkIcon';
import { useAppSelector } from 'src/store';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import PersonIcon from '@mui/icons-material/Person';
import VaccinesIcon from '@mui/icons-material/Vaccines';
import AssessmentIcon from '@mui/icons-material/Assessment';

export interface IIconButtonProps extends IconButtonProps {
  customType?: buttonType;
  loading?: boolean;
  children?: ReactNode;
  authCode?: string;
  modul?: ModulEnum;
  label?: string;
  toolTip?: string; //Dom hatası verdiği için {} = props; a tanımlandı.
};

const translatePath = "components|iconbtn";
const IconButton = (props: IIconButtonProps): JSX.Element => {
  const { customType, loading, authCode, modul, toolTip, ...rest } = props;
  let icon: ReactNode = props.children;
  const formSize = useAppSelector(s => s.userLogin.formSize);
  const iconSx: SxProps<Theme> = {
    width: formSize * 2 + "px",
    height: formSize * 2 + "px"
  }
  switch (customType) {
    case 'undo':
      icon = (
        <Tooltip title={toolTip ? toolTip : translate(translatePath, 'Geri Al')}>
          <UndoIcon
            sx={iconSx}
            color={rest.disabled ? 'disabled' : 'primary'}
          />
        </Tooltip>
      );
      break;
    case 'add':
      icon = (
        <Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'Ekle')}>
          <AddIcon
            // fontSize={props.size}
            sx={iconSx}
            color={rest.disabled ? 'disabled' : 'primary'}
          />
        </Tooltip>
      );
      break;
    case 'search':
      icon = (
        <Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'Arama')}>
          <SearchIcon
            // fontSize={props.size}
            sx={iconSx}
            color={rest.disabled ? 'disabled' : 'primary'}
          />
        </Tooltip>
      );
      break;
    case 'cancel':
      icon = (
        <Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'Vazgeç')}>
          <ClearIcon
            // fontSize={props.size}
            sx={iconSx}
            color={rest.disabled ? 'disabled' : 'error'}
          />
        </Tooltip>
      );
      break;
    case 'close':
      icon = (
        <Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'Kapat')}>
          <CloseIcon
            // fontSize={props.size}
            sx={iconSx}
            color={rest.disabled ? 'disabled' : 'error'}
          />
        </Tooltip>
      );
      break;
    case 'edit':
      icon = (
        <Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'Düzenle')}>
          <EditIcon
            // fontSize={props.size}
            sx={iconSx}
            color={rest.disabled ? 'disabled' : 'primary'}
          />
        </Tooltip>
      );
      break;
    case 'delete':
      icon = (
        <Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'Sil')}>
          <DeleteIcon
            // fontSize={props.size}
            sx={iconSx}
            color={rest.disabled ? 'disabled' : 'error'}
          />
        </Tooltip>
      );
      break;
    case 'save':
      icon = (
        <Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'Kaydet')}>
          <SaveIcon
            // fontSize={props.size}
            sx={iconSx}
            color={rest.disabled ? 'disabled' : 'success'}
          />
        </Tooltip>
      );
      break;
    case 'detail':
      icon = (
        <Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'Detaylar')}>
          <AutoAwesomeMosaicIcon
            // fontSize={props.size}
            sx={iconSx}
            color={rest.disabled ? 'disabled' : 'primary'}
          />
        </Tooltip>
      );
      break;
    case 'back':
      icon = (
        <Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'Geri')}>
          <ArrowBackIcon
            // fontSize={props.size}
            sx={iconSx}
            color={rest.disabled ? 'disabled' : 'primary'}
          />
        </Tooltip>
      );
      break;
    case 'mailSend':
      icon = (
        <Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'E-Posta Gönder')}>
          <ForwardToInboxIcon
            // fontSize={props.size}
            sx={iconSx}
            color={rest.disabled ? 'disabled' : 'primary'}
          />
        </Tooltip>
      );
      break;
    case 'mail':
      icon = (
        <Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'E-Posta')}>
          <MailOutlineIcon
            // fontSize={props.size}
            sx={iconSx}
            color={rest.disabled ? 'disabled' : 'primary'}
          />
        </Tooltip>
      );
      break;
    case 'print':
      icon = (
        <Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'Yazdır')}>
          <PrintIcon
            // fontSize={props.size}
            sx={iconSx}
            color={rest.disabled ? 'disabled' : 'primary'}
          />
        </Tooltip>
      );
      break;
    case 'return':
      icon = (
        <Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'Geri')}>
          <KeyboardReturnIcon
            // fontSize={props.size}
            sx={iconSx}
            color={rest.disabled ? 'disabled' : 'warning'}
          />
        </Tooltip>
      );
      break;
    case 'send':
      icon = (
        <Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'Gönder')}>
          <SendIcon
            // fontSize={props.size}
            sx={iconSx}
            color={rest.disabled ? 'disabled' : 'success'}
          />
        </Tooltip>
      );
      break;
    case 'cancelsend':
      icon = (
        <Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'Geri Al')}>
          <CancelScheduleSendIcon
            // fontSize={props.size}
            sx={iconSx}
            color={rest.disabled ? 'disabled' : 'error'}
          />
        </Tooltip>
      );
      break;
    case 'tilloff':
      icon = (
        <WorkOffIcon
          // fontSize={props.size}
          sx={iconSx}
          color={rest.disabled ? 'disabled' : 'primary'}
        />
      );
      break;
    case 'check':
      icon = (
        <Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'Seç')}>
          <FactCheckIcon
            // fontSize={props.size}
            sx={iconSx}
            color={rest.disabled ? 'disabled' : 'primary'}
          />
        </Tooltip>
      );
      break;
    case 'accept':
      icon = (
        <Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'Onayla')}>
          <CheckIcon
            // fontSize={props.size}
            sx={iconSx}
            color={rest.disabled ? 'disabled' : 'primary'}
          />
        </Tooltip>
      );
      break;
    case 'discard':
      icon = (
        <RemoveIcon
          // fontSize={props.size}
          sx={iconSx}
          color={rest.disabled ? 'disabled' : 'error'}
        />
      );
      break;
    case 'deny':
      icon = (<Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'Red')}>
        <DoDisturbIcon
          // fontSize={props.size}
          sx={iconSx}
          color={rest.disabled ? 'disabled' : 'error'}
        />
      </Tooltip>
      );
      break;
    case 'policy':
      icon = (<Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'Yasal Dayanak')}>
        <PolicyIcon
          // fontSize={props.size}
          sx={iconSx}
          color={rest.disabled ? 'disabled' : 'primary'}
        />
      </Tooltip>
      );
      break;
    case 'details':
      icon = (<Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'Detaylar')}>
        <ContentCopyIcon
          // fontSize={props.size}
          sx={iconSx}
          color={rest.disabled ? 'disabled' : 'primary'}
        />
      </Tooltip>
      );
      break;
    case 'forward':
      icon = (<Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'İleri')}>
        <ArrowForwardIcon
          // fontSize={props.size}
          sx={iconSx}
          color={rest.disabled ? 'disabled' : 'primary'}
        />
      </Tooltip>
      );
      break;
    case 'clear':
      icon = (<Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'Temizle')}>
        <HighlightOffIcon
          // fontSize={props.size}
          sx={iconSx}
          color={rest.disabled ? 'disabled' : 'primary'}
        />
      </Tooltip>
      );
      break;
    case 'checkall':
      icon = (<Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'İleri')}>
        <CheckCircleIcon
          // fontSize={props.size}
          sx={iconSx}
          color={rest.disabled ? 'disabled' : 'primary'}
        />
      </Tooltip>
      );
      break;
    case 'video':
      icon = (<Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'Video')}>
        <VideocamIcon
          // fontSize={props.size}
          sx={iconSx}
          color={rest.disabled ? 'disabled' : 'primary'}
        />
      </Tooltip>
      );
      break;
    case 'organization':
      icon = (<Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'Organizasyon')}>
        <DomainAddIcon
          // fontSize={props.size}
          sx={iconSx}
          color={rest.disabled ? 'disabled' : 'primary'}
        />
      </Tooltip>
      );
      break;
    case 'gridColSave':
      icon = (<Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'Kolonları Özelleştir')}>
        <Grading
          // fontSize={props.size}
          sx={iconSx}
          color={rest.disabled ? 'disabled' : 'primary'}
        />
      </Tooltip>
      );
      break;
    case 'gridColDel':
      icon = (<Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'Özelleştirmeyi İptal Et')}>
        <DisabledByDefault
          // fontSize={props.size}
          sx={iconSx}
          color={rest.disabled ? 'disabled' : 'primary'}
        />
      </Tooltip>
      );
      break;
    case 'upload':
      icon = (<Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'Dosya Yükle')}>
        <DriveFolderUploadIcon
          sx={iconSx}
          color={rest.disabled ? 'disabled' : 'primary'}
        />
      </Tooltip>
      );
      break;
    case 'download':
      icon = (<Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'Dosya İndir')}>
        <DownloadIcon
          sx={iconSx}
          color={rest.disabled ? 'disabled' : 'primary'}
        />
      </Tooltip>
      );
      break;
    case 'view':
      icon = (<Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'Görüntüle')}>
        <PanoramaIcon
          sx={iconSx}
          color={rest.disabled ? 'disabled' : 'primary'}
        />
      </Tooltip>
      );
      break;
    case 'change':
      icon = (<Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'Değiştir')}>
        <ChangeCircleIcon
          sx={iconSx}
          color={rest.disabled ? 'disabled' : 'primary'}
        />
      </Tooltip>
      );
      break;
    case 'transfer':
      icon = (<Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'Şablon Aktar')}>
        <MoveDown
          sx={iconSx}
          color={rest.disabled ? 'disabled' : 'warning'}
        />
      </Tooltip>
      );
      break;
    case 'numunereddet':
      icon = (
        <Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'Numune Reddet')}>
          <ScienceIcon
            sx={iconSx}
            color={rest.disabled ? 'disabled' : props?.color ? props.color : "error" as any}
          />
        </Tooltip>
      );
      break;
    case "sgk":
      icon = (
        <Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'Medula Takibi')}>
          <div style={{ display: "flex" }}>
            <SgkIcon
              sx={iconSx}
              color={rest.disabled ? 'disabled' : "info"}
            />
          </div>
        </Tooltip>
      );
      break;
    case "pdf":
      icon = (
        <Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'Pdf Görüntüle')}>
          <div style={{ display: "flex" }}>
            <PictureAsPdf
              sx={iconSx}
              color={rest.disabled ? 'disabled' : "primary"}
            />
          </div>
        </Tooltip>
      );
      break;
    case "star":
      icon = (
        <Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'Favori Çıkart')}>
          <div style={{ display: "flex" }}>
            <Star
              sx={iconSx}
              color={rest.disabled ? 'disabled' : "warning"}
            />
          </div>
        </Tooltip>
      );
      break;
    case "change2":
      icon = (
        <Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, "Değiştir")}>
          <div style={{ display: "flex" }}>
            <SwapHorizontalCircle
              sx={iconSx}
              color={rest.disabled ? "disabled" : "action"}
            />
          </div>
        </Tooltip>
      )
      break;
    case "unstar":
      icon = (
        <Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'Favori Yap')}>
          <div style={{ display: "flex" }}>
            <StarBorder
              sx={iconSx}
              color={rest.disabled ? 'disabled' : "warning"}
            />
          </div>
        </Tooltip>
      );
      break;
    case "visibility":
      icon = (
        <Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'Önizle')}>
          <div style={{ display: "flex" }}>
            <VisibilityIcon
              sx={iconSx}
              color={rest.disabled ? 'disabled' : "primary"}
            />
          </div>
        </Tooltip>
      );
      break;
    case "photo":
      icon = (
        <Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'Favori Yap')}>
          <div style={{ display: "flex" }}>
            <PhotoCameraIcon
              sx={iconSx}
              color={rest.disabled ? 'disabled' : "warning"}
            />
          </div>
        </Tooltip>
      );
      break;
    case "inventory":
      icon = (
        <Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'Aktarım')}>
          <div style={{ display: "flex" }}>
            <Inventory2Icon
              sx={iconSx}
              color={rest.disabled ? 'disabled' : "info"}
            />
          </div>
        </Tooltip>
      );
      break;
    case "compareArrows":
      icon = (
        <Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'Transfer')}>
          <div style={{ display: "flex" }}>
            <CompareArrowsIcon
              sx={iconSx}
              color={rest.disabled ? 'disabled' : "success"}
            />
          </div>
        </Tooltip>
      );
      break;
    case "Person":
      icon = (
        <Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'Personel')}>
          <div style={{ display: "flex" }}>
            <PersonIcon
              sx={iconSx}
              color={rest.disabled ? 'disabled' : "success"}
            />
          </div>
        </Tooltip>
      );
      break;
    case "test-data-based":
      icon = (
        <Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'Teste ve Veriye Göre')}>
          <div style={{ display: "flex" }}>
            <AssessmentIcon
              sx={iconSx}
              color={rest.disabled ? 'disabled' : "success"}
            />
          </div>
        </Tooltip>
      );
      break;
    case "Medicine":
      icon = (
        <Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'Ilaç')}>
          <div style={{ display: "flex" }}>
            <VaccinesIcon
              sx={iconSx}
              color={rest.disabled ? 'disabled' : "success"}
            />
          </div>
        </Tooltip>
      );
      break;
    case 'digitalSign':
      icon = (
        <Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'Dijital Imza')}>
          <div style={{ display: "flex" }}>
            <BorderColor sx={iconSx} color="info" />
          </div>
        </Tooltip>
      );
      break;
    case "kritik-deger":
      icon = (
        <Tooltip disableInteractive title={toolTip ? toolTip : translate(translatePath, 'Kritik Değer Bildirimi')}>
          <div style={{ display: "flex" }}>
            <NotificationImportant
              sx={iconSx}
              color={rest.disabled ? 'disabled' : "action"}
            />
          </div>
        </Tooltip>
      );
      break;
  };
  return (
    isVisible(authCode, modul) && (
      <MuiIconButton {...rest} size={'small'}>
        {loading ? (
          <CircularProgress size="1.5rem"></CircularProgress>
        ) : (
          <>
            {icon} {props.label}
          </>
        )}
      </MuiIconButton>
    )
  );
};

export default IconButton;
